import { render, staticRenderFns } from "./hallmark.vue?vue&type=template&id=9124c942&"
import script from "./hallmark.vue?vue&type=script&lang=js&"
export * from "./hallmark.vue?vue&type=script&lang=js&"
import style0 from "./hallmark.vue?vue&type=style&index=0&id=9124c942&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports